import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-header" }
const _hoisted_2 = { class: "section-title" }

import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSectionHeader',
  props: {
    title: {},
    expanded: { type: [Boolean, null], default: null }
  },
  emits: ["toggle"],
  setup(__props: any) {

const props = __props;



const isToggleable = computed(() => props.expanded !== null);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(__props.title), 1),
    (isToggleable.value)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          icon: "",
          variant: "tonal",
          size: "x-small",
          color: "primary",
          class: "section-action",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { size: "24" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.expanded ? "mdi-chevron-up" : "mdi-chevron-down"), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})